import { z } from 'zod';

import { AI_MODEL_CHOICE_OPTIONS, PROJECT_TYPE } from './constants';

export const zodFilteredProjectsQueryParametersSchema = z.object({
  filterType: z.enum(PROJECT_TYPE).prefault('all').catch('all'),
  forceRefresh: z.boolean().optional().prefault(false),
  modelChoice: z.enum(AI_MODEL_CHOICE_OPTIONS).optional().prefault('di'),
});
